import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import ChatIcon from '@heroicons/react/outline/ChatIcon';
import ShareIcon from '@heroicons/react/outline/ShareIcon';
import clsx from 'clsx';
import useWebShare from 'react-use-web-share';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import useMobileDetect from 'use-mobile-detect-hook';
import { NetworkVisibility } from '@tribeplatform/gql-client/types';
import { useNetwork } from '@tribeplatform/react-sdk/hooks';
import { Button } from '@tribeplatform/react-ui-kit/Button';
import { Card } from '@tribeplatform/react-ui-kit/Card';
import { useI18n } from '../i18n';
import { ShareModal } from '../ShareModal';
import { FollowAction } from './Actions/FollowAction';
import { LikeAction } from './Actions/LikeAction';
export const PostActionBar = ({ post, actions, isLastChild = false, style, showIcon = true, showText = true, fullWidth = true, }) => {
    var _a;
    const intl = useI18n();
    if (!actions) {
        actions = ['like', 'follow', 'share'];
    }
    const { data: network } = useNetwork();
    const [shareModal, setShareModal] = useState(false);
    const { isSupported, share } = useWebShare();
    const detectMobile = useMobileDetect();
    const isPrivate = ((_a = post === null || post === void 0 ? void 0 : post.space) === null || _a === void 0 ? void 0 : _a.private) || (network === null || network === void 0 ? void 0 : network.visibility) === NetworkVisibility.private;
    const postUrl = post === null || post === void 0 ? void 0 : post.url;
    const allActions = useMemo(() => ({
        like: {
            Component: LikeAction,
        },
        reply: {
            icon: ChatIcon,
            text: intl.$t({
                id: 'Generics.Reply',
                defaultMessage: 'Reply',
            }),
        },
        follow: {
            Component: FollowAction,
        },
        share: {
            icon: ShareIcon,
            text: intl.$t({
                id: 'Generics.Share',
                defaultMessage: 'Share',
            }),
            action: () => {
                if (!isPrivate && isSupported && detectMobile.isMobile()) {
                    share({ title: post.title, url: postUrl });
                }
                else {
                    setShareModal(true);
                }
            },
        },
    }), [intl, isPrivate, isSupported, detectMobile, share, post.title, postUrl]);
    return (_jsxs(_Fragment, { children: [_jsx(Card.Content, { className: clsx('flex space-s-4 py-0 sm:p-1 sm:px-6 min-w-0', isLastChild && 'pb-3'), style: style, children: actions.map(key => {
                    const action = allActions[key];
                    if (!action) {
                        return null;
                    }
                    if (action.Component) {
                        return (_jsx("div", { className: clsx('min-w-0', fullWidth && 'flex-1'), children: _jsx(action.Component, { post: post, showIcon: showIcon, showText: showText }, void 0) }, key));
                    }
                    return (_jsx("div", { className: clsx('flex min-w-0', fullWidth && 'flex-1'), children: _jsx(Button, { variant: "outline", onClick: action.action, className: "group select-none", size: "md", fullWidth: true, leadingIcon: showIcon ? (_jsx(action.icon, { className: "w-6 h-6 transition-transform group-hover:-rotate-12 shrink-0" }, void 0)) : null, children: showText && _jsx("div", { className: "truncate", children: action.text }, void 0) }, void 0) }, key));
                }) }, void 0), _jsx(ShareModal, { isPrivate: isPrivate, open: shareModal, onClose: () => setShareModal(false), title: post.title, postId: post.id, url: postUrl }, void 0)] }, void 0));
};
//# sourceMappingURL=PostActionBar.js.map